import PrefetchUtilState from './actions/helper/PrefetchUtilState';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { LazyAction, LazyModule } from 'owa-bundling';

import { ClientItemId } from 'owa-client-ids';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailPrefetch", webpackPrefetch: true */ './lazyIndex')
);

export { PrefetchUtilState, TableView, ClientItemId };

// Delay actions
export let lazyPrefetchRowInCache = new LazyAction(lazyModule, m => m.prefetchRowInCache);
export let lazyPrefetchSingleRow = new LazyAction(lazyModule, m => m.prefetchSingleRow);
export let lazyPrefetchFirstN = new LazyAction(lazyModule, m => m.prefetchFirstN);

export let lazyPrefetchAdjacentRowsOnDelay = new LazyAction(
    lazyModule,
    m => m.prefetchAdjacentRowsOnDelay
);
